var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgStarFilled24(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.0004 1.45312C12.2859 1.45312 12.5466 1.61516 12.6729 1.87112L15.3709 7.33633L21.389 8.23558C21.6712 8.27776 21.9051 8.47647 21.9923 8.74821C22.0795 9.01996 22.0049 9.31764 21.7999 9.51616L17.4457 13.7321L18.4829 19.7476C18.5314 20.029 18.4159 20.3136 18.1849 20.4816C17.9539 20.6495 17.6476 20.6718 17.3948 20.5389L12.0004 17.7034L6.60601 20.5389C6.35322 20.6718 6.0469 20.6495 5.81593 20.4816C5.58496 20.3136 5.46943 20.029 5.51796 19.7476L6.55511 13.7321L2.20097 9.51616C1.99594 9.31764 1.92135 9.01996 2.00854 8.74821C2.09572 8.47647 2.32958 8.27776 2.61184 8.23558L8.62988 7.33633L11.3279 1.87112C11.4543 1.61516 11.715 1.45312 12.0004 1.45312ZM14.2504 10.5C14.2504 10.9142 13.9146 11.25 13.5004 11.25C13.0862 11.25 12.7504 10.9142 12.7504 10.5C12.7504 10.0858 13.0862 9.75 13.5004 9.75C13.9146 9.75 14.2504 10.0858 14.2504 10.5Z",
    fill: "currentColor",
    strokeWidth: 0
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgStarFilled24);
export default __webpack_public_path__ + "static/media/StarFilled-24.8f818418.svg";
export { ForwardRef as ReactComponent };